import { LoginService } from './../../_services/login.service';
import { EditProfileComponent } from './../edit-profile/edit-profile.component';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss']
})
export class ProfileDetailsComponent implements OnInit {

  ProfileDetails: any;
  successMessage: string;
  errorMessage: string;


  constructor(private modalService: NgbModal, private _loginservice: LoginService, private _localstorageservice: LocalStorageService) { }

  ngOnInit() {
    this.getuserDetails()
  }


  getuserDetails() {
    this._loginservice.fetchuserdetails(this._localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        this.ProfileDetails = res.data
      }
    })
  }
  EditProfileDetails() {
    const modalRef = this.modalService.open(EditProfileComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.backupProfileobj = this.ProfileDetails;
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'success') {
        this.successMessage = "Details Saved Succesfully";
        setTimeout(() => this.successMessage = '', 5000);
        this.getuserDetails();
      } else if (x == 'error') {
        this.errorMessage = "Something went Wrong";
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }

  changepasswordmodal(){
    const modalRef = this.modalService.open(ChangePasswordComponent, { size: 'lg' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.ProfileDetails = this.ProfileDetails;
    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'success') {
        this.successMessage = "Details Saved Succesfully";
        setTimeout(() => this.successMessage = '', 5000);
        this.getuserDetails();
      } else if (x == 'error') {
        this.errorMessage = "Something went Wrong";
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  }
}
